import { type PeriodItem, type PeriodSection, type PlanShare, type Transaction } from '@fin/shared';












export type Line = Pick<PeriodItem, 'section' | 'name' | 'amount' | 'currency' | 'categoryId' | 'debtId' | 'goalId' | 'walletId' | 'highlight'> & { id: number; included?: boolean; done?: boolean; shares?: PlanShare[] };

export const emptyLine = { categoryId: null, debtId: null, goalId: null, walletId: null, highlight: false };

export const sectionTitles: Record<PeriodSection, string> = { mandatory: 'Обязательные', optional: 'Лимиты', foreign: 'В валюте' };

export const isHeld = (it: PeriodItem) => !it.paid && it.held > 0 && !!it.reserveWalletId;

export const isReserveLeg = (t: Transaction, it: PeriodItem) => !!t.transferId && !!it.reserveWalletId && t.counterpartWalletId === it.reserveWalletId;

export const canHold = (it: PeriodItem) => it.section === 'mandatory' && it.included && !it.walletId && !it.goalId;

export const RESERVE_NAME = 'Обязательные траты';

export type LineKind = 'purchase' | 'transfer' | 'debt' | 'goal';

export const lineKindOf = (l: Pick<Line, 'walletId' | 'debtId' | 'goalId'>): LineKind =>
  l.walletId ? 'transfer' : l.debtId ? 'debt' : l.goalId ? 'goal' : 'purchase';

export const lineKinds: { value: LineKind; label: string }[] = [
  { value: 'purchase', label: 'Покупка' }, { value: 'transfer', label: 'Перевод' }, { value: 'debt', label: 'Долг' }, { value: 'goal', label: 'Цель' },
];
